<mat-form-field appearance="outline" *ngIf="!isCreating">
  <mat-label>Mot-clés</mat-label>
  <mat-chip-grid #chipList>
    <mat-chip-row
      *ngFor="let keyword of selectedKeywords;let indx=index;"
      (removed)="remove(indx)">
      {{keyword.label}}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      placeholder="Nouveau mot-clé.."
      #keywordInput
      [formControl]="keywordsCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    >
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let keyword of filteredKeywords$ | async" [value]="keyword">
      {{keyword.label}}
    </mat-option>
    <mat-option *ngIf="showCreateOption" [value]="createOptionValue">
      Créer « {{typed}} »
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<div class="create-keyword" *ngIf="isCreating">
  <p class="create-keyword__title">Nouveau mot-clé : « {{typed}} »</p>
  <mat-form-field appearance="outline" *ngIf="disciplineds.length > 0">
    <mat-label>Discipline</mat-label>
    <mat-select [(value)]="selectedDisciplinedId">
      <mat-option *ngFor="let disciplined of disciplineds" [value]="disciplined.id">
        {{disciplined.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <p class="create-keyword__hint" *ngIf="disciplineds.length === 0">
    Aucune discipline disponible. Veuillez d'abord créer une discipline.
  </p>
  <div class="create-keyword__actions">
    <button mat-button type="button" (click)="cancelCreate()">Annuler</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="selectedDisciplinedId === undefined"
      (click)="confirmCreate()">
      Créer le mot-clé
    </button>
  </div>
</div>
